import React from 'react'
import ProjectDetails from '../container/ProjectDetails'
import ProjectCard from '../container/ProjectCard'

const Project = () => {
  return (
    <div>
      <ProjectDetails/>
      <ProjectCard/>
    </div>
  )
}

export default Project
